import actionCreatorFactory from "typescript-fsa";
import { CommonAsyncType } from "../../core/types";
import { DistrictRequestBody, DistrictResponse } from "../../core/api/request/search/district/types";
import { CommuneRequestBody, CommuneResponse } from "../../core/api/request/search/commune/types";
import { PopularPlaceRequestBody, PopularPlaceResponse } from "../../core/api/request/search/popular-place/types";
import { PropertyTypeRequestBody, PropertyTypeResponse } from "../../core/api/request/search/property-type/types";

const actionCreator = actionCreatorFactory("@@Search");

export const searchActions = {
    getDistricts: actionCreator.async<CommonAsyncType<DistrictResponse> & DistrictRequestBody, DistrictResponse>("GET_DISTRICTS"),
    getCommunes: actionCreator.async<CommonAsyncType<CommuneResponse> & CommuneRequestBody, CommuneResponse>("GET_COMMUNES"),
    getPopularPlaces: actionCreator.async<CommonAsyncType<PopularPlaceResponse> & PopularPlaceRequestBody, PopularPlaceResponse>("GET_POPULAR_PLACES"),
    getPropertTypes: actionCreator.async<CommonAsyncType<PropertyTypeResponse> & PropertyTypeRequestBody, PropertyTypeResponse>("GET_PROPERTY_TYPES"),
    resetToIntialState: actionCreator("RESET_TO_INITIAL_STATE"),
}